import { useParams } from 'react-router-dom';

import { Icon } from '../icon';
import { PDFViewer } from '../pdf-viewer';
import { CloseIcon } from '../pdf-viewer/components/close-icon';
import { useGetAllDocumentsCase } from '@/api/queries/useGetAllDocumentsCase';
import { useGetDoc } from '@/api/queries/useGetDoc';
import { Drawer } from '@/new/components/drawers/drawer';

interface DocumentDrawerProps {
  docId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function DocumentDrawer({ docId, isOpen, onClose }: DocumentDrawerProps) {
  const { matterId } = useParams();
  if (!matterId) {
    return null;
  }
  // Get the caseId of the all documents case
  const { data: allDocumentsCase, isLoading: isLoadingCase } = useGetAllDocumentsCase(matterId);
  const caseId = allDocumentsCase?.id ?? null;
  const { data: doc, isLoading: isLoadingDoc, error } = useGetDoc(caseId, docId);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      <div className="flex h-full flex-col">
        <CloseIcon onClick={onClose} />
        {error ? (
          <div className="my-10 flex h-full w-full flex-col items-center justify-center text-red-600">
            <Icon className="lucide--warning text-2xl" />
            <div className="font-semibold">Sorry, there was a problem loading this document.</div>
            <div className="mt-2 text-xs text-gray-500">Please try again or contact support if the issue persists.</div>
          </div>
        ) : (
          <>
            {(isLoadingCase || isLoadingDoc) && (
              <div className="my-20 flex h-full w-full items-center justify-center">
                <Icon className="lucide--loader-2 animate-spin duration-700" />
              </div>
            )}
            {doc && caseId && docId && (
              <div className="flex-1 overflow-hidden">
                <PDFViewer
                  matterId={matterId}
                  docId={docId}
                  highlights={[]}
                  hideFeatureButtons={true}
                  hideSnippingTool={true}
                  fileName={doc.file?.name}
                />
              </div>
            )}
          </>
        )}
      </div>
    </Drawer>
  );
}
